import React, { useEffect, useState } from 'react'
import {Input} from 'antd';
import {useSelector} from 'react-redux'; 
// import axios from 'axios';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinnerThird} from '@fortawesome/pro-duotone-svg-icons';
import { useNCM } from '../../useProduto';

const InputNCM = (props)=> {

    const {value, getApi, onChange, ...otherProps} = props
    const {produto} = useSelector(state => state.produto)
    const {consultaPorcentagemAprxImpostos} = useNCM(getApi);

    const ncmInicial = {
        codigo: '',
        porcentagemAproximadaImpostos: ""
    }


    
    const [ncm, setNCM] = useState(ncmInicial);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(value){
            if(typeof value == "string"){
                const codigo = value;
                const novoNCM = Object.assign({}, ncm, {codigo});
                console.log("novo ncm", novoNCM);
                setNCM(novoNCM);
                
            } else {
                setNCM(value);
            }
        }

    }, [value])
    

    const preencheDadosNCM = async (value)=> {
        setLoading(true);
        try{

            const porcentagemAproximadaImpostos = await consultaPorcentagemAprxImpostos(produto, value);
    
            const novoNCM = {codigo: value, porcentagemAproximadaImpostos};
            setNCM(novoNCM);
    
            onChange && onChange(novoNCM);
        } catch(err){
            // const novoNCM = {codigo: value, porcentagemAproximadaImpostos: ""};
            // setNCM(novoNCM);
    
            console.log(err);
        } finally{
            setLoading(false);;
        }
    }
    
    const onChangeHandler = async ({target})=> {
        const {value} = target;

        const regexNCMValue = /^\d{0,8}$/gm;
        if(!regexNCMValue.test(value)){
            return ;
        }

        if(value && value.length == 8){

            preencheDadosNCM(value);
            const novoNCM = Object.assign({}, ncm, {codigo: value});
            setNCM(novoNCM)
            onChange && onChange(novoNCM);
            return;
        }

        const novoNCM = Object.assign({},ncmInicial, {codigo: value});
        setNCM(novoNCM);
        onChange && onChange(novoNCM);
        
    }

    let suffix = ''
    if(loading){
        suffix = <FontAwesomeIcon icon={faSpinnerThird} spin ></FontAwesomeIcon>
    }

    return <Input {...otherProps} addonAfter={suffix}  onChange={onChangeHandler} value={ncm.codigo} />

}

export {InputNCM}